import { RoutePath } from 'consts/RoutePath';

export const MenuConst = {
	ACCOUNT_INFO: {
		key: 'ACCOUNT_INFO',
		label: '登録情報',
		link: RoutePath.ACCOUNT_INFO,
		image: 'register.svg',
		selectedImage: 'register_selected.svg',
	},
	PASSWORD_EDIT: {
		key: 'PASSWORD_EDIT',
		label: 'パスワード情報',
		link: RoutePath.PASSWORD_EDIT,
		image: 'password.svg',
		selectedImage: 'password_selected.svg',
	},
	CARD_MANAGEMENT: {
		key: 'CARD_MANAGEMENT',
		label: 'お支払い情報',
		link: RoutePath.CARD_MANAGEMENT,
		image: 'payment.svg',
		selectedImage: 'payment_selected.svg',
	},
	FAMILY_INFO: {
		key: 'FAMILY_INFO',
		label: '家族情報',
		link: RoutePath.FAMILY_INFO,
		image: 'family.svg',
		selectedImage: 'family_selected.svg',
	},
	EMAIL_DELIVERY: {
		key: 'EMAIL_DELIVERY',
		label: 'メール配信',
		link: RoutePath.EMAIL_DELIVERY,
		image: 'email.svg',
		selectedImage: 'email_selected.svg',
	},
	WITHDRAW: {
		key: 'WITHDRAW',
		label: '退会',
		link: RoutePath.WITHDRAW,
		image: 'withdrawal.svg',
		selectedImage: 'withdrawal_selected.svg',
	},
	WITHDRAW_CONTACT_FORM: {
		key: 'WITHDRAW_CONTACT_FORM',
		label: '退会',
		link: RoutePath.WITHDRAW_CONTACT_FORM,
		image: 'withdrawal.svg',
		selectedImage: 'withdrawal_selected.svg',
	},
} as const;
export type MenuType = typeof MenuConst[keyof typeof MenuConst];

export const findMenuByKey = (key: string) => {
	return Object.values(MenuConst).find((m) => m.key === key);
};
